/*
 * https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
 */
export enum GoogleGeocoderAddressComponentType {
  /*
   * Indicates an incorporated city or town political entity.
   *
   * Used for `GooglePlace.suburb`.
   */
  Locality = "locality",
  /*
   * Indicates a first-order civil entity below the country level.
   * Within the United States, these administrative levels are states.
   * Not all nations exhibit these administrative levels. In most cases,
   * administrative_area_level_1 short names will closely match ISO 3166-2
   * subdivisions and other widely circulated lists; however this is not
   * guaranteed as our geocoding results are based on a variety of signals
   * and location data.
   *
   * Used for `GooglePlace.state`.
   */
  AdministrativeAreaLevel1 = "administrative_area_level_1",
  /*
   * Indicates a postal code as used to address postal mail within the country.
   *
   * Used for `GooglePlace.postcode`.
   */
  PostalCode = "postal_code",
  /*
   * Indicates the national political entity, and is typically
   * the highest order type returned by the Geocoder.
   *
   * Used for `GooglePlace.country.name` and  `GooglePlace.country.code`.
   */
  Country = "country",
}
